import type {DeviceType} from '@/redux/middleware/googleTagManager/types';

import {isMobile, isTablet, osName} from 'react-device-detect';

import {
  DEVICE_TYPE_DESKTOP,
  DEVICE_TYPE_MOBILE,
  DEVICE_TYPE_TABLET,
  SCREEN_ORIENTATION_LANDSCAPE,
  SCREEN_ORIENTATION_PORTRAIT,
} from '@/redux/middleware/googleTagManager/types';

/**
 * parameters only used for testing
 * as mocking & changing the mock for more than 1 test is not possible
 *
 * @todo remove the parameters and find a better way to test
 */
export const getDeviceType = (
  isTab: boolean = isTablet,
  isMob: boolean = isMobile
): DeviceType => {
  if (isTab) {
    return DEVICE_TYPE_TABLET;
  }
  if (isMob) {
    return DEVICE_TYPE_MOBILE;
  }
  // There are other device types too (smartv, wearable, ...).
  // Our tracking spec however only expects three.
  // So at this point we bunch the rest together as "desktop".
  return DEVICE_TYPE_DESKTOP;
};

export const getOperatingSystem = (): string => osName;

export const getScreenOrientation = () => {
  if (window.matchMedia('(orientation: portrait)').matches) {
    return SCREEN_ORIENTATION_PORTRAIT;
  }
  if (window.matchMedia('(orientation: landscape)').matches) {
    return SCREEN_ORIENTATION_LANDSCAPE;
  }
  // we should never get here
  return undefined;
};
